import { differenceInSeconds } from 'date-fns'
import { useEffect, useState } from 'react'

export function useTimer() {
  const [id, setId] = useState<NodeJS.Timer | null>(null)
  const [seconds, setSeconds] = useState(Infinity)

  const isCounting = id != null

  const tick = (expiryTimestamp: number) => setSeconds(differenceInSeconds(new Date(expiryTimestamp * 1000), new Date()))

  useEffect(() => {
    if (seconds <= 0 && id != null) {
      clearInterval(id)
      setId(null)
      setSeconds(Infinity)
    }
  }, [id, seconds])

  // NOTE: 將小數計算誤差加上
  const oneSecond = 1
  const startTimer = (expiryTimestamp: number) => {
    if (id != null) throw new Error('Timer has been started!')
    setId(setInterval(() => tick(expiryTimestamp + oneSecond), 1000))
  }

  return {
    startTimer,
    seconds: seconds === Infinity ? 0 : seconds,
    isCounting,
  }
}
